/* 전역 토스트 — ToastProvider 로 감싸고, 어느 feature에서나 useToast()로 호출.
   (예전 app.jsx 의 window.__admToast setTimeout 패턴을 Context 로 이전)

   toast(msg)            → 성공(초록 체크) — 기존 호출부 호환(기본값).
   toast(msg, 'error')   → 실패(빨강 경고). plan §S5-4 "성공 토스트 일관 + 실패 메시지 통일".
   toast(msg, 'info')    → 정보(중립). */
import { createContext, useContext, useCallback, useRef, useState } from 'react';
import { Icon } from '../icons/Icon.jsx';

const ToastContext = createContext(() => {});

const VARIANTS = {
  success: { icon: 'check', color: '#6ee7b7' },
  error:   { icon: 'close', color: '#fca5a5' },
  info:    { icon: 'help',  color: '#93c5fd' },
};

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);   // { msg, type }
  const timer = useRef(null);
  const show = useCallback((msg, type = 'success') => {
    setToast({ msg, type: VARIANTS[type] ? type : 'success' });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), 2600);
  }, []);
  const v = toast ? VARIANTS[toast.type] : null;
  return (
    <ToastContext.Provider value={show}>
      {children}
      {toast && (
        <div className={'toast toast--' + toast.type}>
          <Icon name={v.icon} size={16} stroke={2.4} style={{ color: v.color }} />
          {toast.msg}
        </div>
      )}
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);

export default ToastProvider;
